package org.hs_soft.runmynesto.domain.util

object IdUtils
{
    const val defaultValues="defaultValues"
    const val dashboardItemId="dashboardItemId"
    const val companyName="companyName"
    const val language="language_"
    const val shopList="shopList"
    const val advertisingDuringTyping="advertisingDuringTyping"
    const val fullDisplayAdvertising="fullDisplayAdvertising"
    const val logoImg="logoImg"
    const val heroGoogleImg="heroGoogleImg"
    const val wideCompanyLogo="wideCompanyLogo"
    const val wideLogoImg="wideLogoImg"
    const val productsDB="products_data4"
    const val companyProfileId="companyProfileId21"
    const val favoriteMessages="favoriteMessages"
    const val authToken="authToken"
    const val checkOutList="checkOutList2"
    const val salesChartId="salesChartId"
    const val clientChartId="clientChartId"

    const val animationAppConstantsType=76
    const val paymentTerminalType=82
    const val unitSales=34

}